const UNDERAGE_URL_PARAM = "depotType=underage";
export default UNDERAGE_URL_PARAM;
